import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useOrdersStore } from '@widgets/orders'
import { toIdValue } from '@shared/lib/routes'

import { defineNuxtRouteMiddleware } from '#app'

/**
 * Runs after `orders` (which maps the query onto the shared store) and narrows the list to the
 * customer of the page — the id comes from the path, never from the query.
 */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  useOrdersStore().setFilterCustomerId(toIdValue(to.params.id))
})
